import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoDrive = () => {
  return (
    <g>
      <path d="M16 10.673 13.51 15H3.801l2.49-4.327H16zM4.792 2.1 7.34 6.538 2.509 14.92 0 10.6 4.792 2.1zm5.72-1.1 5.178 8.872h-5.007L5.505 1h5.007z" />
    </g>
  );
};

export default withIcon(IconLogoDrive);
